import { GridFooterCellProps } from '@progress/kendo-react-grid';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { round } from 'src/utils';
import { getBgColor } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';

const InvoicePercentageFooterCell = (props: GridFooterCellProps) => {
  const totalPercentage = useContextSelector(InvoiceContext, (value) => value.totalPercentage);
  const errorMessage = useContextSelector(InvoiceContext, (value) => value.errorMessage);
  const footerInfoMessage = useContextSelector(InvoiceContext, (value) => value.footerInfoMessage);
  return (
    <td className={getBgColor(errorMessage.totalPercentage, [], footerInfoMessage)}>
      <p className="text-left">{round(totalPercentage)}%</p>
    </td>
  );
};

export default InvoicePercentageFooterCell;
